const GetThemeClass = (lightClass, darkClass) => {
  const theme = localStorage.getItem("theme");
  return theme === "dark" ? darkClass : lightClass;
};

export default GetThemeClass;
